import { ClientLog } from 'src/constants/clientLog';
import ClientLogger from 'src/utils/logger';
import katalMetricsPublisher from './katalMetricsPublisher';

/**
 * Publishes API duration metrics for Seller University API calls
 * Uses 'API.{endpointName}' as the actionId for easy querying and filtering
 * Tracks total duration (including retries) and separate error counts
 * @param endpointName - The RTK Query endpoint name (e.g., 'getLearningPathwayStatic')
 * @param duration - The total duration of the API call in milliseconds (includes all retries)
 * @param isError - Whether the API call resulted in an error (default: false)
 */
export const publishApiDurationMetric = (
  endpointName: string,
  duration: number,
  isError: boolean = false,
): void => {
  try {
    const publisher = katalMetricsPublisher
      .newChildActionPublisherForMethod(`API.${endpointName}`);

    // Track total duration for all calls (including retry time)
    publisher.publishCounterMonitor('APITotalDuration', duration);

    // Track errors as separate counter metric
    if (isError) {
      publisher.publishCounterMonitor('APIErrorCount', 1);
    }
  } catch (error) {
    // Log as warning since this is infrastructure issue, not application logic failure
    // This prevents metrics failures from causing cascading errors and double logging
    ClientLogger.warn(ClientLog.MetricsFailure, error instanceof Error ? error : new Error(String(error)), {
      context: 'API metrics publishing failed - this does not affect API functionality',
      endpoint: endpointName,
      duration,
      isError,
      possibleCause: 'KatalMetrics publisher initialization failed',
      impact: 'API call completed successfully, only metrics collection affected',
      currentUrl: window.location.href,
    });
  }
};
